var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-container',[_c('h1',[_vm._v("PAYOUTS")]),_c('b-nav',[_c('b-nav-item',{attrs:{"to":{name: 'PayoutsHistory'}}},[_vm._v("HISTORY")])],1)],1),_c('b-container',{staticClass:"pt-2"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3899f52d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Payouts.vue
// module id = null
// module chunks = 